import React from 'react';


import {BulkActionTool} from 'src/components/bulk-tool';
import {bulkDischargeUserEntitlements, getDischargeUserEntitlementsProgress} from 'src/openapi/admin/apis/BulkDischargeUserEntitlementsApi';
import {useAppDispatch} from 'src/store/hooks';

import {FlatButton} from '@pb/kit-component-button';
import {useShown} from '@pb/kit-hooks-use-shown';

import {
    MODAL_WIDTH,
    TOOL_PROGRESS_LABEL,
    TOOL_STACK_OVERFLOW_MESSAGE,
    TOOL_TASK,
    TOOL_TITLE,
} from './constants';
import {UnassignUserEntitlementsModal} from './unassign-user-entitlements.modal';
import {
    selectUnassignUserEntitlementsBulkUuid,
    selectUnassignUserEntitlementsTask,
    setBackgroundTask,
    setShown,
    setUuid,
} from './unassign-user-entitlements.slice';

import type {UpdateUserEntitlementsRelation} from 'src/openapi/admin/models/UpdateUserEntitlementsRelation';

type Props = {
    userId: number,
    selectionKey: string,
    onDone: () => void,
};

export const UnassignUserEntitlementsTool = ({selectionKey, onDone, userId}: Props) => {
    const apiDispatch = useAppDispatch();
    const {shown, onClick, onClose} = useShown();

    return (
        <>
            <FlatButton onClick={onClick}>
                <b>{TOOL_TITLE}</b>
            </FlatButton>
            <BulkActionTool<UpdateUserEntitlementsRelation>
                shown={shown}
                onClose={onClose}
                width={MODAL_WIDTH}

                toolTask={TOOL_TASK}
                toolName={TOOL_TITLE}
                progressLabel={TOOL_PROGRESS_LABEL}

                taskSelector={selectUnassignUserEntitlementsTask}
                uuidSelector={selectUnassignUserEntitlementsBulkUuid}

                setUuid={setUuid}
                setTask={setBackgroundTask}
                setResultShown={setShown}
                saveActionRequest={(updateUserEntitlementsRelation, options) => (
                    apiDispatch(bulkDischargeUserEntitlements({...options, updateUserEntitlementsRelation}))
                )}
                getProgress={id => apiDispatch(getDischargeUserEntitlementsProgress({id}))}

                stackOverflowMessage={TOOL_STACK_OVERFLOW_MESSAGE}
                onDone={onDone}>
                {({processAction, onCloseModal}) => (
                    <UnassignUserEntitlementsModal
                        userId={userId}
                        selectionKey={selectionKey}
                        onCloseModal={onCloseModal}
                        processAction={processAction}
                    />
                )}
            </BulkActionTool>
        </>
    );
};
